import { useEffect, useState } from 'react';

export const useExternalScript = (url: string, excludedPaths?: string[], customProperties?: Record<string, string>) => {
  const [state, setState] = useState(url ? 'loading' : 'idle');

  useEffect(() => {
    if (excludedPaths && excludedPaths.includes(window.location.pathname)) {
      setState('ready');
      return;
    }

    if (!url) {
      setState('idle');
      return;
    }

    let script: HTMLScriptElement | null = document.querySelector(`script[src="${url}"]`);

    const handleScript = (event: Event) => {
      setState(event.type === 'load' ? 'ready' : 'error');
    };

    if (!script) {
      script = document.createElement('script');
      script.type = 'application/javascript';
      script.src = url;
      script.async = false;

      for (const key in customProperties) {
        script.setAttribute(key, customProperties[key]);
      }

      document.body.appendChild(script);
      script.addEventListener('load', handleScript);
      script.addEventListener('error', handleScript);
    }

    script.addEventListener('load', handleScript);
    script.addEventListener('error', handleScript);

    return () => {
      if (script !== null) {
        script.removeEventListener('load', handleScript);
        script.removeEventListener('error', handleScript);
      }
    };
  }, [url, excludedPaths, customProperties]);

  return state;
};
